import { ThhPferdAction, ThhPferdActions } from '../thhPferdActions';
import { AntragsummerGenerated } from '../actiontypes/antragsummerGenerated';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: ThhPferdAction<AntragsummerGenerated>,
): string {
  switch (action.type) {
    case ThhPferdActions.ANTRAGSNUMMER_GENERATED: {
      return action.payload.antragsnummer;
    }
    default:
      return sectionState;
  }
};
